export default [
  {
    path: '/app/account-activities/incomes',
    name: 'AccountIncomes',
    component: () => import('@/views/Admin/Account_activities/Incomes/Index.vue'),
    meta: {
      pageTitle: 'Hesap Hareketleri',
      breadcrumb: [
        {
          text: 'Gelir Girişi',
          active: true,
        },
      ],
      resource: 'ADMIN_ACCOUNT_ACTIVITIES',
      action: 'read',
    },
  },
  {
    path: '/app/account-activities/incomes/edit/:id',
    name: 'AccountIncomeEdit',
    component: () => import('@/views/Admin/Account_activities/Incomes/Edit.vue'),
    meta: {
      pageTitle: 'Hesap Hareketleri',
      breadcrumb: [
        {
          text: 'Gelir Veri Güncellemesi',
          active: true,
        },
      ],
      resource: 'ADMIN_ACCOUNT_ACTIVITIES',
      action: 'read',
    },
  },
  {
    path: '/app/account-activities/expenses',
    name: 'AccountExpenses',
    component: () => import('@/views/Admin/Account_activities/Expenses/Index.vue'),
    meta: {
      pageTitle: 'Hesap Hareketleri',
      breadcrumb: [
        {
          text: 'Gider Girişi',
          active: true,
        },
      ],
      resource: 'ADMIN_ACCOUNT_ACTIVITIES',
      action: 'read',
    },
  },
  {
    path: '/app/account-activities/expenses/edit/:id',
    name: 'AccountExpenseEdit',
    component: () => import('@/views/Admin/Account_activities/Expenses/Edit.vue'),
    meta: {
      pageTitle: 'Hesap Hareketleri',
      breadcrumb: [
        {
          text: 'Gider Veri Güncellemesi',
          active: true,
        },
      ],
      resource: 'ADMIN_ACCOUNT_ACTIVITIES',
      action: 'read',
    },
  },
  {
    path: '/app/account-activities',
    name: 'AccountActivities',
    component: () => import('@/views/Admin/Account_activities/Index.vue'),
    meta: {
      pageTitle: 'Hesap Hareketleri',
      breadcrumb: [
        {
          text: 'Gelirler - Giderler',
          active: true,
        },
      ],
      resource: 'ADMIN_ACCOUNT_ACTIVITIES',
      action: 'read',
    },
  },
  {
    path: '/app/bank-transfer',
    name: 'BankTransfer',
    component: () => import('@/views/Admin/Account_activities/BankTransfer.vue'),
    meta: {
      pageTitle: 'Hesap Hareketleri',
      breadcrumb: [
        {
          text: 'Banka Transfer Listesi',
          active: true,
        },
      ],
      resource: 'ADMIN_ACCOUNT_ACTIVITIES',
      action: 'read',
    },
  },
]
